import React, {FC, useMemo} from "react";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import {Spin} from "antd";
import {useAuthenticateQuery} from "../../generated/graphql";
import {URL_ASSISTANT, URL_ASSISTANT_CHANGELOG, URL_ASSISTANT_HOME, URL_ASSISTANT_LOGIN, URL_ASSISTANT_MY, URL_ASSISTANT_PROFILE} from "../../models/url";
import AssistantHome from "./AssistantHome";
import AssistantLogin from "./AssistantLogin";
import AssistantMyAssignments from "./AssistantMyAssignments";
import AssistantProfile from "./AssistantProfile";
import AssistantChangelog from "./AssistantChangelog";
import AssistantLayout from "./AssistantLayout";
import {useAssistantTheme} from "./AssistantThemeContext";
import styles from "./assistantApp.less";

const AssistantRoutes: FC = () => {
    const {data, loading} = useAuthenticateQuery();
    const {resolvedTheme} = useAssistantTheme();

    const isLoggedIn = useMemo(() => {
        return Boolean(data?.authenticate?.id);
    }, [data]);

    if (loading) {
        const themeClass = resolvedTheme === "dark" ? styles["assistant-theme-dark"] : styles["assistant-theme-light"];
        return (
            <div className={`${themeClass} ${styles.assistantLoading}`}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <Router>
            <Switch>
                <Route exact path={URL_ASSISTANT}>
                    <Redirect to={isLoggedIn ? URL_ASSISTANT_HOME : URL_ASSISTANT_LOGIN} />
                </Route>
                <Route exact path={URL_ASSISTANT_LOGIN} component={AssistantLogin} />
                <Route exact path={URL_ASSISTANT_HOME} render={() => (isLoggedIn ? <AssistantLayout><AssistantHome /></AssistantLayout> : <Redirect to={URL_ASSISTANT_LOGIN} />)} />
                <Route exact path={URL_ASSISTANT_MY} render={() => (isLoggedIn ? <AssistantLayout><AssistantMyAssignments /></AssistantLayout> : <Redirect to={URL_ASSISTANT_LOGIN} />)} />
                <Route exact path={URL_ASSISTANT_PROFILE} render={() => (isLoggedIn ? <AssistantLayout><AssistantProfile /></AssistantLayout> : <Redirect to={URL_ASSISTANT_LOGIN} />)} />
                <Route exact path={URL_ASSISTANT_CHANGELOG} render={() => (isLoggedIn ? <AssistantLayout><AssistantChangelog /></AssistantLayout> : <Redirect to={URL_ASSISTANT_LOGIN} />)} />
                <Route>
                    <Redirect to={URL_ASSISTANT} />
                </Route>
            </Switch>
        </Router>
    );
};

export default AssistantRoutes;
